module.exports = __webpack_public_path__ + "img/9788994475554.f96374ee.jpg";